import React, { Component } from 'react'
import { translate } from 'react-multi-lang'
import addBrTag from '../utils/add-br-tag'
import Services from '../services'

import './about.css';

class About extends Component {

	static displayName = 'About'

	constructor(props) {

		super(props)

		this.state = {
			display: 'generic'
		}
	}

	componentDidMount() {

		Services.getPrices().then(({ display }) => {

			this.setState({ display })
		})
	}

	render() {

		const { t } = this.props
		const display = this.state.display
		const priceInfo = display === "pro" ? t('about.priceInfoPro') : " "

		return (
			<div className='about'>

				{/* <div className='about-title'>{addBrTag(t('about.title'))}</div> */}

				<div className='logo'>
					<img alt='logo' {...{
						className: 'logo-img',
						height: 200,
						src: './products-images-wines/logo.jpg',
					}} />
				</div>

				<br />

				<div className='about-text'>{addBrTag(t('about.part1'))}</div>
				<div className='about-text'>{addBrTag(t('about.part2'))}</div>

				<div className='about-delivery-info'>{addBrTag(t('about.deliveryInfo'))}</div>

				{priceInfo !== " " && <div className='about-price-info'>{priceInfo}</div>}

			</div>
		)
	}
}

export default translate(About)